import Line from "../../../../../src/entities/Line/Line";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { Coord } from "../../../../../src/types/Interface";


export default class LineManager {
	private cCoord: Coord;
	lines = [new Line({ color: 0xb06efe, isEqualSymbol: true }), new Line({ color: 0xb06efe, isEqualSymbol: true }), new Line()]
	constructor(cCoord: Coord) {
		this.cCoord = cCoord;
		rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.clearAll())
	}
	clearAll = () => this.lines.forEach(l => l.clear());
	draw(points: Coord[], sidePoints: Coord[]) {
		this.lines[0].draw(sidePoints[0], sidePoints[1]);
		this.lines[1].draw(sidePoints[1], sidePoints[2]);
		this.lines[2].draw(this.cCoord, points[0]);
	}
}